module.exports = __webpack_public_path__ + "static/img/microcuencas.9d476678.png";